import {
  LayoutDashboard, BookOpen, History, Zap, BarChart2, Target, Settings, Bookmark, AlertTriangle,
} from "lucide-react";

// Portal accent classes (literal strings so Tailwind keeps them).
export const ACCENTS = {
  blue: {
    active: "bg-blue-600 text-white",
    solid: "bg-blue-600 hover:bg-blue-700 text-white",
    text: "text-blue-600",
    softBg: "bg-blue-50",
    softText: "text-blue-700",
    ring: "focus-visible:ring-blue-500",
    badge: "bg-blue-600",
    icon: "text-blue-600",
    iconSoft: "bg-blue-50 text-blue-600",
  },
  violet: {
    active: "bg-violet-600 text-white",
    solid: "bg-violet-600 hover:bg-violet-700 text-white",
    text: "text-violet-600",
    softBg: "bg-violet-50",
    softText: "text-violet-700",
    ring: "focus-visible:ring-violet-500",
    badge: "bg-violet-600",
    icon: "text-violet-600",
    iconSoft: "bg-violet-50 text-violet-600",
  },
  emerald: {
    active: "bg-emerald-600 text-white",
    solid: "bg-emerald-600 hover:bg-emerald-700 text-white",
    text: "text-emerald-600",
    softBg: "bg-emerald-50",
    softText: "text-emerald-700",
    ring: "focus-visible:ring-emerald-500",
    badge: "bg-emerald-600",
    icon: "text-emerald-600",
    iconSoft: "bg-emerald-50 text-emerald-600",
  },
};

export const STUDENT_PORTAL = {
  label: "Student Portal",
  accent: "blue",
  nav: [
    { icon: LayoutDashboard, label: "Dashboard", to: "/student" },
    { icon: BookOpen, label: "Practice", to: "/student/practice" },
    { icon: History, label: "Previous Years", to: "/student/practice/pyq" },
    { icon: Zap, label: "AI Questions", to: "/student/practice/ai" },
    { icon: Bookmark, label: "Bookmarks", to: "/student/bookmarks" },
    { icon: AlertTriangle, label: "Revise Mistakes", to: "/student/mistakes" },
    { section: "Analytics" },
    { icon: BarChart2, label: "Performance", to: "/student/performance" },
    { icon: Target, label: "Weak Areas", to: "/student/weak-areas" },
    { section: "Account" },
    { icon: Settings, label: "Settings", to: "/student/settings" },
  ],
};

export const PAGE_TITLES = {
  "/student": "Dashboard",
  "/student/practice": "Practice",
  "/student/practice/pyq": "Previous Year Questions",
  "/student/practice/ai": "AI Questions",
  "/student/bookmarks": "Bookmarks",
  "/student/mistakes": "Revise Mistakes",
  "/student/session": "Practice Session",
  "/student/performance": "Performance",
  "/student/weak-areas": "Weak Areas",
  "/student/settings": "Settings",
};
